export const stylePoster = {
  normal: {
    minHeight: '400px',
    width: '250px',
    transform: 'scale(0.9)',
    borderRadius: '10px',
    transitionProperty: 'transform',
    transitionDuration: '0.5s',
    transitionTimingFunction: 'ease-in-out',
  },
  hovered: {
    minHeight: '400px',
    width: '250px',
    borderRadius: '10px',
    transform: 'scale(1)',
    transitionProperty: 'transform',
    transitionDuration: '0.5s',
    transitionTimingFunction: 'ease-in-out',
    zIndex: '1',
  },
}
